function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import Dialog from 'antd/lib/modal';
import ActionButton from 'antd/lib/modal/ActionButton';
import { getConfirmLocale } from 'antd/lib/modal/locale';
import { noop } from '../../utils/noop';
var IS_REACT_16 = !!ReactDOM.createPortal;

var ConfirmDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfirmDialog, _React$Component);

  var _super = _createSuper(ConfirmDialog);

  function ConfirmDialog(props) {
    var _this;

    _classCallCheck(this, ConfirmDialog);

    _this = _super.call(this, props);

    _this.handleOk = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ev) {
        var confirmed;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.setState({
                  error: undefined
                });

              case 2:
                _context.next = 4;
                return _this.props.confirm(_assertThisInitialized(_this));

              case 4:
                confirmed = _context.sent;

                if (confirmed) {
                  if (_this.props.onOk) {
                    _this.props.onOk();
                  }

                  _this.close();
                }

                return _context.abrupt("return");

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleCancel = function () {
      _this.close();
    };

    _this.state = {};
    return _this;
  }

  _createClass(ConfirmDialog, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var onCancel = props.onCancel,
          close = props.close,
          zIndex = props.zIndex,
          afterClose = props.afterClose,
          visible = props.visible,
          keyboard = props.keyboard,
          centered = props.centered,
          getContainer = props.getContainer,
          okButtonProps = props.okButtonProps,
          cancelButtonProps = props.cancelButtonProps;
      var iconType = props.iconType || 'question-circle';
      var okType = props.okType || 'primary';
      var prefixCls = props.prefixCls || 'ant-confirm'; // 默认为 true，保持向下兼容

      var okCancel = 'okCancel' in props ? props.okCancel : true;
      var width = props.width || 416;
      var style = props.style || {}; // 默认为 false，保持旧版默认行为

      var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
      var runtimeLocale = getConfirmLocale();
      var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
      var cancelText = props.cancelText || runtimeLocale.cancelText;
      var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
      var classString = classNames(prefixCls, "".concat(prefixCls, "-").concat(!props.type ? 'type-unknown' : props.type.toString()), props.className, 'aqe-modal-confirm', 'aqe-modal-confirm-custom-body');
      var cancelButton = okCancel && /*#__PURE__*/React.createElement(ActionButton, {
        prefixCls: prefixCls,
        actionFn: onCancel,
        closeModal: close,
        autoFocus: autoFocusButton === 'cancel',
        buttonProps: cancelButtonProps
      }, cancelText);
      return /*#__PURE__*/React.createElement(Dialog, {
        className: classString,
        wrapClassName: classNames(_defineProperty({}, "".concat(prefixCls, "-centered"), !!props.centered)),
        onCancel: this.handleCancel,
        visible: visible,
        title: "",
        transitionName: "zoom",
        footer: "",
        maskTransitionName: "fade",
        maskClosable: maskClosable,
        style: style,
        width: width,
        zIndex: zIndex,
        afterClose: afterClose,
        keyboard: keyboard,
        centered: centered,
        getContainer: getContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-header")
      }, /*#__PURE__*/React.createElement(LegacyIcon, {
        type: iconType,
        theme: 'filled'
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-title")
      }, props.title)), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-body")
      }, props.content, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-confirmation-body")
      }, this.state.error && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-confirmation-error")
      }, this.state.error))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-btns")
      }, cancelButton, /*#__PURE__*/React.createElement(ActionButton, {
        prefixCls: prefixCls,
        type: okType,
        actionFn: this.handleOk,
        closeModal: noop,
        autoFocus: autoFocusButton === 'ok',
        buttonProps: okButtonProps
      }, okText))));
    }
  }, {
    key: "close",
    value: function close() {
      this.props.close.call(this, {
        triggerCancel: true
      });
    }
  }]);

  return ConfirmDialog;
}(React.Component);

export function confirmWithCustomBody(config) {
  var div = document.createElement('div');
  document.body.appendChild(div);

  var currentConfig = _objectSpread(_objectSpread({}, config), {}, {
    close: close,
    visible: true
  });

  function close() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // @ts-ignore
    // tslint:disable-next-line:no-invalid-this
    var boundDestroy = destroy.bind.apply(destroy, [this].concat(args));
    currentConfig = _objectSpread(_objectSpread({}, currentConfig), {}, {
      visible: false,
      afterClose: boundDestroy
    });

    if (IS_REACT_16) {
      render(currentConfig);
    } else {
      destroy.apply(void 0, args);
    }
  }

  function update(newConfig) {
    currentConfig = _objectSpread(_objectSpread({}, currentConfig), newConfig);
    render(currentConfig);
  }

  function destroy() {
    var unmountResult = ReactDOM.unmountComponentAtNode(div);

    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var triggerCancel = args && args.length && args.some(function (param) {
      return param && param.triggerCancel;
    });

    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(config, args);
    }
  }

  function render(props) {
    ReactDOM.render( /*#__PURE__*/React.createElement(ConfirmDialog, props), div);
  }

  render(currentConfig);
  return {
    destroy: close,
    update: update
  };
}